import { COURSE_API_KEYS, normalizeMultilineText } from './eventFormConstants';
import { DESCRIPTION_MAX, getEmptyDish, MENU_COURSES } from './manageEventForm';

export const isMenuEmpty = (menuSections = []) =>
  !menuSections.some((section) =>
    section.dishes?.some(
      (dish) =>
        dish.dishName?.trim() ||
        dish.description?.trim() ||
        Boolean(dish.imagePreview) ||
        dish.imageFile instanceof File,
    ),
  );

export const countMenuDishesWithContent = (menuSections = []) =>
  menuSections.reduce((total, section) => {
    const withContent =
      section.dishes?.filter(
        (dish) =>
          dish.dishName?.trim() ||
          dish.description?.trim() ||
          Boolean(dish.imagePreview) ||
          dish.imageFile instanceof File,
      ).length ?? 0;
    return total + withContent;
  }, 0);

const mapExtractedItemsToDishes = (items = []) =>
  items.map((item) => ({
    ...getEmptyDish(),
    dishName: item.dishName ?? '',
    description: normalizeMultilineText(item.description ?? '').slice(0, DESCRIPTION_MAX),
  }));

/** @param {'append' | 'replace'} mode */
export const applyExtractedMenuItems = (menuSections, extractedMenuItems = {}, mode = 'replace') =>
  MENU_COURSES.map((course, sectionIndex) => {
    const apiKey = COURSE_API_KEYS[course];
    const incoming = mapExtractedItemsToDishes(extractedMenuItems[apiKey] ?? []);
    const existing = menuSections[sectionIndex]?.dishes ?? [];

    return {
      course,
      dishes: mode === 'append' ? [...existing, ...incoming] : incoming,
    };
  });
